export default __webpack_public_path__ + "3c59bb3719c676b995d616f11020c3cd.svg";